"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _string = require('shared/services/string');
var _phoneVerifier = require('shared/services/phoneVerifier');

var _phoneMask = require('shared/services/phoneMask');
var _emailVerifier = require('shared/services/emailVerifier');

 const sanitizeExtension = (joi) => ({
  type: 'string',
  base: joi.string(),
  coerce: (v) => ({ value: _string.sanitizeStr.call(void 0, v) }),
  rules: {
    sanitize: {
      convert: true,
      method () { return this.$_addRule('sanitize') },
    },
  },
}); exports.sanitizeExtension = sanitizeExtension

const validateContactPhone = (value, helpers, policy) => {
  const error = _phoneVerifier.getPhoneValidationError.call(void 0, value, policy)
  if (error === _phoneVerifier.PhoneValidationError.UNSUPPORTED_COUNTRY_CODE) {
    return helpers.error('contactPhone.unsupportedCountryCode')
  }
  if (error) return helpers.error('contactPhone.invalid')
  return value
}

 const contactPhoneExtension = (joi) => ({
  type: 'string',
  base: joi.string(),
  messages: {
    'contactPhone.invalid': "Provide a valid phone number",
    'contactPhone.unsupportedCountryCode': "This country code is not supported",
  },
  rules: {
    contactPhone: {
      // policy picks the phone list; omit it for the strict list every phone
      // field uses. Only 2FA for invitees and org members passes 'invitee'.
      method (policy) { return this.$_addRule({ name: 'contactPhone', args: { policy } }) },
      args: [{
        name: 'policy',
        assert: (policy) => policy === undefined || policy === 'strict' || policy === 'invitee',
        message: 'must be a phone policy',
      }],
      validate: (value, helpers, { policy }) => validateContactPhone(value, helpers, policy),
    },
    // A patient's existing number that the server masked for this user
    // passes unchanged: the user can't see it, so they can't re-enter it.
    contactPhoneOrMasked: {
      method () { return this.$_addRule('contactPhoneOrMasked') },
      validate: (value, helpers) => _phoneMask.isMaskedPhone.call(void 0, value)
        ? value
        : validateContactPhone(value, helpers),
    },
  },
}); exports.contactPhoneExtension = contactPhoneExtension

 const contactEmailExtension = (joi) => ({
  type: 'string',
  base: joi.string(),
  messages: {
    'contactEmail.invalid': "Provide a valid email",
    'contactEmail.max': "Email is too long",
  },
  rules: {
    contactEmail: {
      method () { return this.$_addRule('contactEmail') },
      validate: (value, helpers) => {
        if (_emailVerifier.isEmailTooLong.call(void 0, value)) return helpers.error('contactEmail.max')
        if (!_emailVerifier.isEmailValid.call(void 0, value)) return helpers.error('contactEmail.invalid')
        return value
      },
    },
  },
}); exports.contactEmailExtension = contactEmailExtension
